module.exports = __webpack_public_path__ + "static/media/scancode-banner.1a480f41.png";